<template>
    <Dialog
        header="Списать с карты"
        class="flex flex-column border-0"
        modal
        v-model:visible="dialogVisible"
        :breakpoints="{'960px': '75vw', '640px': '90vw'}"
        :style="{width: '30vw'}"
    >
        <div class="w-full mb-3">
            <span class="flex text-600 mb-2 text-sm">
                Сумма:
            </span>
            <InputGroup>
                <InputNumber
                    v-model="amount"
                    :min="0.0000001"
                    :max="getMaxAmount()"
                    :maxFractionDigits="6"
                    :useGrouping="false"
                    size="large"
                    class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2"
                />
                <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                    <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                </InputGroupAddon>
            </InputGroup>
        </div>

        <div class="w-full mb-3">
            <span class="flex text-600 mb-2 text-sm">
                Доступно:
            </span>
            <span class="text-900 font-medium">{{ getFormatAmount(card.balance, card.currency_code) }}</span>
        </div>

        <template #footer>
            <Button label="Списать" @click="submit()" :disabled="!canSubmit" :loading="loading" class="bg-orange-500 border-orange-500 text-white"/>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        card: {
            type: Object,
            default: null,
        },
    },
    emits: ['update:visible', 'success'],
    data() {
        return {
            loading: false,
            amount: null,
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            },
        },
        canSubmit() {
            return !!(this.card && this.card._id && this.card.user_id && this.amount && this.amount > 0)
        },
    },
    watch: {
        visible(value) {
            if (value) this.amount = null
        },
    },
    methods: {
        getFormatAmount(value, currency, digits = 2) {
            if (!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
        getMaxAmount() {
            if (!this.card || !this.card.balance) return 100000000
            return Number(this.card.balance)
        },
        async getClipboardData() {
            try {
                const text = await navigator.clipboard.readText()
                return text
            } catch (error) {
                console.error('Failed to read clipboard contents:', error)
                return null
            }
        },
        put() {
            this.getClipboardData().then(data => {
                if (data && !isNaN(data) && data > 0) this.amount = parseFloat(data)
            })
        },
        close() {
            this.amount = null
            this.dialogVisible = false
        },
        async submit() {
            if (!this.canSubmit) return

            this.loading = true
            const response = await this.connect.AdminWithdrawVcard({
                user_id: this.card.user_id,
                card_id: this.card._id,
                amount: this.amount,
            }).then(res => res)

            if (response.result) {
                this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Списание прошло успешно', life: 2000 })
                this.close()
                this.$emit('success')
            } else {
                if (response.errors && response.errors.length) this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: response.errors[0], life: 3000 })
                else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 3000 })
            }

            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>